<template>
  <el-dialog
    :model-value="visible"
    :title="mode === 'create' ? '新建文件夹' : '编辑文件夹'"
    :width="mode === 'create' ? '760px' : '420px'"
    style="max-width: 92vw"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <el-form :model="form" label-width="80px">
      <el-form-item label="文件夹名称" required>
        <el-input v-model="form.name" placeholder="输入文件夹名称" maxlength="100" />
      </el-form-item>
    </el-form>

    <div v-if="mode === 'create'" class="mt-4 border-t border-slate-100 pt-4">
      <AssetFolderAclEditor
        v-model:visibility-type="visibilityType"
        v-model:acl-items="aclItems"
      />
    </div>

    <template #footer>
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" :disabled="!form.name" :loading="submitting" @click="handleSubmit">
        {{ mode === 'create' ? '创建' : '保存' }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { createFolder, updateFolder } from '@/api/assets'
import AssetFolderAclEditor from './AssetFolderAclEditor.vue'

const props = defineProps({
  visible: { type: Boolean, default: false },
  mode: { type: String, default: 'create' },
  folder: { type: Object, default: null },
  parentId: { type: [Number, String], default: 0 }
})

const emit = defineEmits(['update:visible', 'success'])

const form = reactive({ name: '' })
const submitting = ref(false)
const visibilityType = ref('INHERIT')
const aclItems = ref([])

watch(() => props.visible, (val) => {
  if (val && props.mode === 'edit' && props.folder) {
    form.name = props.folder.name || ''
  } else if (val) {
    form.name = ''
    visibilityType.value = 'INHERIT'
    aclItems.value = []
  }
})

function normalizeSubjectIds(item) {
  if (item.subjectType === 'ALL_AUTHENTICATED') return 0
  const value = item.subjectValue
  const values = Array.isArray(value) ? value : [value]
  return values
    .map(subject => {
      if (subject && typeof subject === 'object') return Number(subject.id) || 0
      return Number(subject) || 0
    })
    .filter(Boolean)
}

function expandAclItems() {
  return aclItems.value.flatMap(item => {
    if (item.subjectType === 'ALL_AUTHENTICATED') {
      return [{
        subjectType: item.subjectType,
        subjectId: normalizeSubjectIds(item),
        permissionLevel: item.permissionLevel
      }]
    }
    return normalizeSubjectIds(item).map(subjectId => ({
      subjectType: item.subjectType,
      subjectId,
      permissionLevel: item.permissionLevel
    }))
  })
}

async function handleSubmit() {
  submitting.value = true
  try {
    if (props.mode === 'create') {
      await createFolder({
        parentId: props.parentId,
        name: form.name,
        visibilityType: visibilityType.value,
        aclList: visibilityType.value === 'CUSTOM'
          ? expandAclItems()
          : []
      })
    } else {
      await updateFolder(props.folder.id, {
        name: form.name,
        lockVersion: props.folder.lockVersion
      })
    }
    ElMessage.success(props.mode === 'create' ? '文件夹已创建' : '文件夹已更新')
    emit('success')
    emit('update:visible', false)
  } catch {
    // handled by interceptor
  } finally {
    submitting.value = false
  }
}
</script>
